import { useReadContract } from "wagmi";
import { useEffect } from "react";
import { NFT_CONTRACT_ADDRESS } from "@/constants/mint";
import { nftAbi } from "@/abi/nftAbi";

export function useTotalSupply() {
  const { data, refetch } = useReadContract({
    abi: nftAbi,
    address: NFT_CONTRACT_ADDRESS,
    functionName: "totalSupply",
  });

  useEffect(() => {
    const interval = setInterval(() => {
      refetch?.();
    }, 5000);
    return () => clearInterval(interval);
  }, [refetch]);

  return data;
}
